import {commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();

const mutation = graphql`
mutation CommunicationTemplateCreateMutation($input: CreateCommunicationTemplateTInput!) {
  createCommunicationTemplateT(input: $input) {
    communicationTemplateT {
      ctId
    }
  }
}
`;

function commit(accountId, usingAccountId, templateName, greeting, body) {
  const variables = {
    input: {
      communicationTemplateT: {
        accountId,
        usingAccountId,
        greeting,
        templateName,
        body
      }
    }
  }

  return new Promise((resolve, reject) => {
    commitMutation(
      abEnvironment.getEnvironment(), {
        mutation,
        variables,
        onCompleted: (response) => {
          //resolve(response.createAccountT.accountT);
          resolve(response);
        },
        onError: (error) => {
          reject(error);
        }
      });
  });
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { commit };
